// src/utils/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { hasPermission, fetchCurrentUser, getUserId } from "./auth";

const ProtectedRoute = ({ screen, action = "View", children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      // Fetch current user if not already fetched
      if (!getUserId()) {
        await fetchCurrentUser();
      }

      const canAccess = getUserId() && hasPermission(screen, action);
      setAuthorized(canAccess);
      setLoading(false);
    };

    checkAuth();
  }, [screen, action]);

  if (loading) return <div>Loading...</div>;
  if (!getUserId()) return <Navigate to="/login" replace />;
  if (!authorized) return <Navigate to="/unauthorized" replace />;

  return children;
};

export default ProtectedRoute;
